import { Stack, Typography } from '@mui/material';
import { AiChatMessage } from 'src/@types/ai';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { HeaderStyled } from './styles';

type Props = {
  message: AiChatMessage;
};

export const ThinkingHeader = ({ message }: Props) => {
  const { translate } = useLocales();

  return (
    <Stack mb={3} width={1}>
      {/* Header */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={0}
      >
        <HeaderStyled>
          {(message.status === 'loading' && message.think) ||
          !message?.parsedContent ? (
            <>
              <Iconify icon="eos-icons:loading" width={20} height={20} />
              <Typography variant="subtitle2">
                {translate('shared.ai_prompt.thinking')}...
              </Typography>
            </>
          ) : (
            <>
              <Iconify icon="tabler:universe" width={20} height={20} />
              <Typography variant="subtitle2">
                {translate('shared.ai_prompt.thinking_process', {
                  thinkingTime: message.thinkingTime,
                })}
              </Typography>
            </>
          )}
        </HeaderStyled>
      </Stack>
    </Stack>
  );
};
